const $ = require('jquery');
const VectorMapConfig = require('./VectorMapConfig');
const constants = require('./../data/constants');
const IWStreetsPostProcessor = require('./IWStreetsPostProcessor');
const Api = require('../ApiV2');

class Map {
  constructor(container, storage, provider, autoresize) {
    this.container = container;
    this.provider = provider;
    this.map = null;
    this._renderer = null;
    window.mapType = 'tomtom-latest';
    this.autoresize = autoresize;
    this.postProcessor = null;
    this.swisstopoPostProcessor = null;

    this.userLocationCoordinates = null;
    this.userLocationCoordinatesDBKey = 'userLocationCoordinates';

    this.contentEditor = null;

    if(provider === constants.PROVIDER_HERE) {
      window.mapType = 'here-latest';
    } else if(provider === constants.PROVIDER_OSM) {
      window.mapType = 'openstreetmap-latest';
    }

    this.storage = storage;
    return new Promise((resolve, reject) => {
      this.storage.init().then(() => {
        this.storage.getOption(this.userLocationCoordinatesDBKey).then((result) => {
          if (result) {
            this.userLocationCoordinates = new window.IWCoordinate(
              result._x, result._y, result._projection,
            );
          }

          resolve(this);
        });
      })
        .catch(error => reject(error));
    });
  }

  init() {
    this.map = new window.IWMap(document.querySelector(this.container));
    this.map.getOptions().setRightMouseAction(window.IWMapOptions.CONTROL_NONE);

    const mapType = this.map.getOptions().getMapTypeByName(window.mapType);

    this.resolveMapCenter();
    //mapType.setRenderingConfig(VectorMapConfig);
    mapType.setMaxLevel(18);

    this.map.setCenter(this.userLocationCoordinates, 12, mapType);

    this.map.setProvider(this.provider);

    /*
    if(Api.isDevelopment()) {
      this.map.setDynamicMapType("TomTom_PLANET_2023_09", "infoware, TomTom 2023/09");
    }
    */

    if(this.provider === constants.PROVIDER_FWW) {
      let mapString = 'infoware, Here_Wuppertal, 2016/06';
      this.map.setDynamicMapType(constants.MAPTYPE_WUPPERTAL, mapString);
    }

    this.addMapListeners();

    this.initPostProcessor();
    this.initSwisstopoPostProcessor();

    this.contentEditor = $('.content-editor');

    /*
    const layer = this.map.getLayoutManager().getLayer(0);
    layer.setBorder(10, 10);
    layer.addControl(new IWScalarControl(this.map), IWAlignment.LEFT, IWAlignment.BOTTOM);
    */
  }

  initMainRenderer() {
    this._renderer = new IWMapRenderer(this.map);
  }

  /**
   * Checks if the are any map coordinates already saved and defaults to either a static location
   * or the user's geo position (if enabled)
   *
   * @return {void}
   */
  resolveMapCenter() {
    if (this.userLocationCoordinates) {
      return;
    }

    this.userLocationCoordinates = new window.IWCoordinate(
      7.1408879, 50.70150837, window.IWCoordinate.WGS84,
    );

    try {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const center = new window.IWCoordinate(longitude, latitude, window.IWCoordinate.WGS84);

          this.updateUserLocationCoordinates(center);
          this.map.setCenter(center);
        },
      );
    } catch (e) {
      console.warn('User location is not available', e);
    }
  }

  addMapListeners() {
    window.IWEventManager.addCustomListener(this.map, 'onmoveend', () => {
      this.updateUserLocationCoordinates(this.map.getCenter().toWGS84());
    });

    $('.zoomIn').on('click', () => {
      this.map.zoomIn();
    });

    $('.zoomOut').on('click', () => {
      this.map.zoomOut();
    });

    $(window).on('resize', () => {
      if(this.autoresize) {
        this.resizeMap();
      }
    })
  }

  updateUserLocationCoordinates(coordinates) {
    this.userLocationCoordinates = coordinates;

    this.storage.putOption(this.userLocationCoordinatesDBKey, coordinates);
  }

  zoomToCoordinates(coordinates, extraZoom) {
    if(coordinates.length < 1) return;
    if (coordinates.length < 2) {
      this.map.setCenter(coordinates[0], 18);
    } else {
      const bounds = new window.IWBounds(coordinates[0], coordinates[1]);

      coordinates.forEach((coordinate, index) => {
        if (index === 0 || index === 1) return;

        bounds.extendBy(coordinate);
      });

      this.map.setCenter(bounds.getCenter(), this.map.getBoundsZoomlevel(bounds)+extraZoom);
    }
  }

  switchBirdseyeView(useBirdseyeView, useWMTSLayer) {
    if(useBirdseyeView) {
      if(useWMTSLayer) {
        this.map.setMapType(this.swisstopoPostProcessor);
      } else {
        let airMapType = this.map.getOptions().getMapTypeByName('google');
        airMapType.setPostProcessor(this.postProcessor);
        this.map.setMapType(airMapType);
      }
    } else {
      const mapType = this.map.getOptions().getMapTypeByName(window.mapType);
      this.map.setMapType(mapType);
    }
  }

  initPostProcessor() {
    let maptype = this.map.getOptions().getMapTypeByName(window.mapType);
    let serverConfig = maptype.getTilesServerConfig();
    let renderingConfig = JSON.parse(JSON.stringify(maptype.getRenderingConfig()));
    this.postProcessor = new IWStreetsPostProcessor(this.map, serverConfig, renderingConfig);
  }

  initSwisstopoPostProcessor() {

    const URL = 'https://wmts.geo.admin.ch/EPSG/3857/1.0.0/WMTSCapabilities.xml';

    let parser = new IWWMTSParser();
    parser.parse(URL, layers => {
      let layer = layers.find(it => it.id === 'ch.swisstopo.swissimage');
      this.swisstopoPostProcessor = IWWMTSUtils.createMapTypeFromWMTSLayer(this.map, layer);
      this.swisstopoPostProcessor.setName('swisstopo-hybrid');

      let copyright = this.map.getOptions().getMapTypeByName(window.mapType).getCopyright();
      copyright =  copyright.slice(0, copyright.indexOf(',')+2) + "swisstopo, " + copyright.slice(copyright.indexOf(',')+2);
      this.swisstopoPostProcessor.setCopyright(copyright);

      let maptype = this.map.getOptions().getMapTypeByName(window.mapType);
      let serverConfig = maptype.getTilesServerConfig();
      let renderingConfig = JSON.parse(JSON.stringify(maptype.getRenderingConfig()));
      let streets = new IWStreetsPostProcessor(this.map, serverConfig, renderingConfig);
      this.swisstopoPostProcessor.setPostProcessor(streets);
    });
  }

  enableRightClickMove(enable) {
    if(enable) {
      this.map.getOptions().setRightMouseAction(IWMapOptions.CONTROL_MOVE)
    } else {
      this.map.getOptions().setRightMouseAction(IWMapOptions.CONTROL_NONE)
    }
  }

  resizeMap() {
    let mapHeight = this.contentEditor.height();
    let mapWidth = this.contentEditor.width();
    this.map.getOptions().setSize(new IWSize(mapWidth, mapHeight));
  }

  /**
   * @return {IWMapRenderer}
   */
  get renderer() {
    return this._renderer;
  }
}

module.exports = Map;
